/**
 * 商品一覧条件管理
 */
class ConditionsController{
    constructor() {
    }
    /* GETクエリをオブジェクトで返す */
    getGetQueryObject(url){
        let results = {_order:[]};
        if(!url){
            url = location.search;
        }
        if(url){
            url = -1 < url.indexOf('?') ? url.split('?').pop() : url;
            const keyValues = url.split('&');
            keyValues.forEach((keyValue,index)=>{
                const parts = keyValue.split('=');
            results._order.push(parts[0]);
            results[parts[0]] = 1 < parts.length ? parts[1] : '';
        });
        }
        return results._order.length ? results : null;
    }
    /* 条件の値をオブジェクトで返す */
    getConditionsObject(){
        let results = {_order:[]};
        let key;
        for(key in this.elements.selectors){
            if(/^cond.+$/.test(key) && this.elements[key]){
                const elm = this.elements[key];
                const nodeName = elm.nodeName.toLowerCase();
                const name = elm.name;
                const type = elm.type;
                let value = elm.value;
                let selectedIndex = -1;
                if(nodeName === 'select'){
                    selectedIndex = elm.selectedIndex;
                }else if(nodeName === 'input' && type === 'checkbox'){
                    const checkedInputs = elm.parentNode.querySelectorAll('[name="'+elm.name+'"]:checked');
                    let values = [];
                    checkedInputs.forEach((elm,index)=>{
                        values.push(elm.value);
                    });
                    value = values.join(',');
                }
                results._order.push(name);
                results[name] = {value:value,selectedIndex:selectedIndex};
            }
        }
        return results._order.length ? results : null;
    }
    /* 条件のnameを配列で返す */
    getConditionsKeys(){
        let results = [];
        let key;
        for(key in this.elements.selectors){
            if(/^cond.+$/.test(key) && this.elements[key]){
                const elm = this.elements[key];
                results.push(elm.name);
            }
        }
        return results;
    }
    /**
     * 初期化
     */
    init(){
        this.elements = {
            selectors : {
                html                            : '',
                body                            : '',
                condAvailability                : '.Collection-detail__main .Filtering__sort [name="filter.v.availability"]',
                condEnd                         : '.Collection-detail__main .Filtering__sort [name="filter.p.m.custom._end"]',
                condLimit                       : '.Collection-detail__main .Filtering__sort [name="limit"]',
                condOrder                       : '.Collection-detail__main .Filtering__sort [name="sort_by"]',
                collectionGridColAll            : '.Collection-detail__main .Collection-detail__grid .Collection-detail__grid-col'
            }
        };
        this.data = {
            requiredConditions : ['sort_by']
        };
        this.initDataElements();
        this.initRequiredConditions();
        this.initEvents();
    }
    /* this.elements初期化 */
    initDataElements(){
        this.elements.html = document.getElementsByTagName('html')[0];
        this.elements.body = document.getElementsByTagName('body')[0];
        let key;
        for(key in this.elements.selectors){
            if(this.elements.selectors[key]) {
                if (/^.+All$/.test(key)) {
                    this.elements[key] = document.querySelectorAll(this.elements.selectors[key]);
                }else {
                    this.elements[key] = document.querySelector(this.elements.selectors[key]);
                }
                if (/^.+Clone$/.test(key)) {
                    this.elements[key] = this.elements[key].cloneNode(true);
                }
            }
        }
    }
    /* sort_byが付いてない場合自動リダイレクト */
    initRequiredConditions(){
        if(!/^\/collections.+$/.test(location.pathname)){
            return;
        }
        let needRedirect = false;
        const urlParams = this.getGetQueryObject();
        if(urlParams){
            this.data.requiredConditions.forEach((key,index)=>{
                if(!urlParams._order.includes(key)){
                    needRedirect = true;
                }
            });
        }else{
            needRedirect = true;
        }
        if(needRedirect){
            this.onChange();
        }else{
            this.elements.collectionGridColAll.forEach((elm,index)=>{
                let style = elm.getAttribute('style');
                if(style){
                    style = style.replace(/visibility ?: ?hidden;/,'');
                    elm.setAttribute('style',style);
                }
            });
        }
    }
    /* イベント初期化 */
    initEvents(){
        let key;
        for(key in this.elements.selectors){
            if(/^cond.+$/.test(key) && this.elements[key]){
                this.elements[key].addEventListener('change',(e)=>{
                    this.onChange(e);
                });
            }
        }
    }
    /* 条件変更時 */
    onChange(e){
        const urlqueries = this.getGetQueryObject();
        const conditionKeys = this.getConditionsKeys();
        const conditions = this.getConditionsObject();
        let keyvalues = {};
        let keyorders = [];
        let search = [];
        if(urlqueries){
            urlqueries._order.forEach((key,index)=>{
                if(!conditionKeys.includes(key)){
                    keyvalues[key] = urlqueries[key];
                    keyorders.push(key);
                }
            });
        }
        conditions._order.forEach((key,index)=>{
            if(conditions[key].value){
                if( this.data.requiredConditions.includes(key) || (!this.data.requiredConditions.includes(key) && conditions[key].selectedIndex) ) {
                    keyvalues[key] = conditions[key].value;
                    if(!keyorders.includes(key)){
                        keyorders.push(key);
                    }
                }
            }
        });
        if(keyorders.length){
            keyorders.forEach((key,index)=>{
                search.push(key + '=' + keyvalues[key]);
            });
        }
        location.search = '?' + search.join('&');
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const cc = new ConditionsController();
    cc.init();
});